import {useEffect} from 'react'
import {Link} from '@primer/react'
import type {BannerProps} from '@primer/react'
import {useAddBanner, useDismissBanner, type InitialBanner} from '@github-ui/banner-stack'
import type {RepositoryRateLimitBannerPayload} from '../../routes/workflows-layout-route'

export const REPOSITORY_RATE_LIMIT_BANNER_ID = 'repository-rate-limit-banner'

type RepositoryRateLimitBanner = InitialBanner & BannerProps & {'data-test-selector'?: string}

export function getRepositoryRateLimitBanner({
  title,
  message,
  documentationUrl,
}: RepositoryRateLimitBannerPayload): RepositoryRateLimitBanner {
  return {
    id: REPOSITORY_RATE_LIMIT_BANNER_ID,
    title,
    description: (
      <>
        {message}{' '}
        <Link inline href={documentationUrl}>
          Learn more about GitHub Actions limits
        </Link>
      </>
    ),
    variant: 'warning',
    'data-test-selector': REPOSITORY_RATE_LIMIT_BANNER_ID,
  }
}

export function useRepositoryRateLimitBanner({data}: {data?: RepositoryRateLimitBannerPayload | null}) {
  const addBanner = useAddBanner()
  const dismissBanner = useDismissBanner()

  useEffect(() => {
    if (!data) return

    const id = addBanner(getRepositoryRateLimitBanner(data))

    return () => {
      dismissBanner(id)
    }
  }, [data, addBanner, dismissBanner])
}
